import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { LessonPlansPage } from './lesson-plans.page';
import { ComponentsModule } from '../../components/components.module';
import { CourseComponent } from './course/course.component';
import { CourseLessonListComponent } from './course-lesson-list/course-lesson-list.component';
import { CourseHeaderEditComponent } from './course-header-edit/course-header-edit.component';
import { LessonTileComponent } from './lesson-tile/lesson-tile.component';
import { CourseCssService} from './course-css.service'

import { DragulaModule, DragulaService } from 'ng2-dragula'

const routes: Routes = [
  {
    path: '',
    component: LessonPlansPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    DragulaModule
  ],
  declarations: [LessonPlansPage, CourseComponent, CourseLessonListComponent, CourseHeaderEditComponent, LessonTileComponent],
  providers: [CourseCssService, DragulaService]
})
export class LessonPlansPageModule {}
